export default __webpack_public_path__ + "static/media/payroll-feature-processing.de5cf15c.svg";